import {React, useState} from 'react';
import '../../App.css'
import {Grid, Box, Button, Paper, FormControl,InputLabel, Select, MenuItem, FormHelperText, Typography} from '@mui/material';
import {CurrencyRuble} from '@mui/icons-material';
import * as monthList from '../../services/monthList';
import * as yearList from '../../services/yearList';
import PTReportTable from '../table-data/PTReportTable';

const RequiredLabel = ({ label }) => (
  <span>
    {label}
    <span style={{ color: 'red' , marginLeft: '3px'}}>*</span>
  </span>
);

const monthOptions = monthList.getMonthList();
const yearOptions = yearList.getYearList();

const today = new Date();
const currentYear = today.getFullYear().toString();
const currentMonthIndex = today.getMonth();
const currentMonthName = monthOptions[currentMonthIndex].title;

const initialFValues={
  id: 0,
  month: currentMonthName,
  year: currentYear,
}

function ProfessionalTaxReport(){

  const validate = () => {
    let temp = {}
    temp.month = values.month.length != 0 ? "" : "This field is required."
    temp.year = values.year.length != 0 ? "" : "This field is required."

    setErrors({
      ...temp
    })

    return Object.values(temp).every(x => x == "")
  }

  const [values, setValues] = useState(initialFValues);
  const [errors, setErrors] = useState({});
  const [openPopup, setOpenPopup] = useState(false);

  function handleInputChange(e){
    const {name, value} = e.target;
    setValues({
      ...values,
      [name]: value
    })
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ""
      });
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    if(validate())
      alert("Submitted!");
  }

  return(
    <Box sx={{display: "flex" ,justifyContent: "center", margin: "10px", padding: "50px", fontWeight: "500px"}}>
      <Paper elevation={5} sx={{width: "1000px",height: "290px"}}>
        <Grid className="form-title" container spacing={2} justifyContent="center" style={{marginTop: "15px"}} alignItems="center">
          <Grid item> <CurrencyRuble sx={{width: 45, height: 45}}/> </Grid>
          <Grid item> <Typography variant="h5">Professional Tax Report</Typography> </Grid>
        </Grid>
        <form className="classes.root" autoComplete="off" onSubmit={handleSubmit}>

          <Box sx={{margin: "30px"}}>
            {/* All elements in one line */}
            <Box sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 2,
              flexWrap: 'wrap'
            }}>
              
              {/* Month field */}
              <FormControl
                variant="outlined"
                sx={{ width: '200px' }}
                {...(errors.month && {error:true} )}
              >
                <InputLabel><RequiredLabel label="Month" /></InputLabel>
                <Select
                  label="Month"
                  name="month"
                  size="small"
                  value={values.month}
                  onChange={handleInputChange}
                >
                  <MenuItem value="">None</MenuItem>
                  {
                    monthOptions.map(
                      item => (<MenuItem key={item.id} value={item.title}>{item.title}</MenuItem>)
                    )
                  }
                </Select>
                { errors.month && <FormHelperText>{errors.month}</FormHelperText>}
              </FormControl>

              {/* Year field */}
              <FormControl
                variant="outlined"
                sx={{ width: '200px' }}
                {...(errors.year && {error:true} )}
              >
                <InputLabel><RequiredLabel label="Year" /></InputLabel>
                <Select
                  label="Year"
                  name="year"
                  size="small"
                  value={values.year}
                  onChange={handleInputChange}
                >
                  <MenuItem value="">None</MenuItem>
                  {
                    yearOptions.map(
                      item => (<MenuItem key={item.id} value={item.title}>{item.title}</MenuItem>)
                    )
                  }
                </Select>
                { errors.year && <FormHelperText>{errors.year}</FormHelperText>}
              </FormControl>

              {/* Buttons in a row */}
              <Box sx={{ display: 'flex', gap: 2 }}>
                <Button className="form-btn" color="success" variant="contained" type="submit" sx={{ height: 40 }}>
                  Display
                </Button>
                <Button variant="outlined" color="secondary" sx={{ height: 40 }}>
                  Print
                </Button>
                <Button variant="outlined" color="primary" sx={{ height: 40 }}>
                  Export to Excel
                </Button>
              </Box>
            </Box>
          </Box>

          <div style={{padding: 20}}><PTReportTable/></div>

        </form>
      </Paper>
    </Box>
  )
}

export default ProfessionalTaxReport;